import React from 'react'
import {
  VideoSection,
  VideoThumbnail,
  VideoOverlay,
  PlayButton,
  PlayIcon,
  BrandLogo,
  VideoLabels,
  Label,
  ChatbotsLabel
} from './KnowledgeStyles'

const VideoPreview: React.FC = () => {
  return (
    <VideoSection>
      <VideoThumbnail>
        <BrandLogo>botgo</BrandLogo>
        <VideoOverlay>
          <PlayButton>
            <PlayIcon>▶</PlayIcon>
          </PlayButton>
          <VideoLabels>
            <Label>Automatically</Label>
            <Label>up-to-date!</Label>
          </VideoLabels>
          <ChatbotsLabel>Chatbots</ChatbotsLabel>
        </VideoOverlay>
      </VideoThumbnail>
    </VideoSection>
  )
}

export default VideoPreview
